import { LayoutHOC } from 'base/ui/layout/layout';
import { createWorkOrder } from './workOrder';

export const createWorkOrderPage = (layoutHOC: LayoutHOC) => {
  return layoutHOC(createWorkOrder());
};
